import { render, staticRenderFns } from "./MSelectComp.vue?vue&type=template&id=4cc90f70&"
import script from "./MSelectComp.vue?vue&type=script&lang=js&"
export * from "./MSelectComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports